import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { routes, selectIsLoggedIn, selectIsOwnerOrAdmin, useLayout } from '@cloud/shared';
import { cssVar } from 'ovpn-ui-toolkit';

const execZendeskCommand = (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
        // Zendesk is disabled in dev mode, see index.hbs
        return;
    }

    try {
        const zeApi = (window as any).zE;

        // to support old and new ZE versions
        const zeFn = zeApi.widget === 'messenger' ? 'messenger' : 'webWidget';
        zeApi(zeFn, ...args);
    } catch (e) {
        console.warn('Zendesk command failed with error: ', e);
    }
};

function forceHideWidget() {
    const hideWidgetStyles = `
    iframe[title='Button to launch messaging window'],
    iframe[title='Message from company'],
    iframe[title='Close message'] {
        display: none !important;
    }
`;
    const style = document.createElement('style');
    style.appendChild(document.createTextNode(hideWidgetStyles));
    document.getElementsByTagName('head')[0].appendChild(style);
}

const changeZendeskOffset = (offset: number) => {
    cssVar.setNumber('--zendesk-bottom-offset', offset);
};

const PAGE_OFFSET = 60;

const subscriptionsRoute = '/billing/subscriptions';
const newSubscriptionRoute = '/billing/domain-create';
const noOffsetPages = [
    routes.cyberShieldV2.overview,
    routes.statusPage,
    subscriptionsRoute,
    newSubscriptionRoute,
];

export function useHelpWidget() {
    const { pathname } = useLocation();
    const { isMobile } = useLayout();
    const isLoggedIn = useSelector(selectIsLoggedIn);
    const isOwnerOrAdmin = useSelector(selectIsOwnerOrAdmin);

    useEffect(() => {
        if (isLoggedIn) {
            if (noOffsetPages.some(page => pathname.startsWith(page))) {
                changeZendeskOffset(0);
            } else {
                changeZendeskOffset(PAGE_OFFSET);
            }
        }
    }, [pathname, isLoggedIn]);

    useEffect(() => {
        if (isLoggedIn) {
            /* Always hide zendesk on mobile devices and in the user portal */
            if (!isOwnerOrAdmin || isMobile) {
                execZendeskCommand('hide');

                if (!isOwnerOrAdmin) {
                    forceHideWidget();
                }
            } else {
                execZendeskCommand('show');
            }
        }
    }, [isOwnerOrAdmin, isLoggedIn, isMobile]);
}
